import React, { useState, useEffect, useCallback } from "react";
import { TaskStateType } from "../types/types";
import useTimeout from "./useTimeout";
const useAlert = (): [
  boolean,
  string,
  boolean,
  (msg: string, stateType: TaskStateType) => void
] => {
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const { clear: clearOpen, reset: resetOpen } = useTimeout(() => {
    setIsOpen(false);
  }, 1500);
  const { clear, reset } = useTimeout(() => {
    setAlertContent("");
  }, 1600);
  useEffect(() => {
    clearOpen();
    clear();
  }, []);
  useEffect(() => {
    if (alertContent) {
      resetOpen();
      reset();
    }
  }, [alertContent]);
  const setOptionalAlertContent = useCallback(
    (msg: string, stateType: TaskStateType) => {
      if (!msg) return;
      switch (stateType) {
        case TaskStateType.SUCCESS:
          setIsError(false);
          break;
        case TaskStateType.FAIL:
          setIsError(true);
          break;
      }
      setIsOpen(true);
      setAlertContent(msg);
    },
    [setAlertContent]
  );
  return [isOpen, alertContent, isError, setOptionalAlertContent];
};
export default useAlert;
